import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { FacebookIcon, TwitterIcon, WhatsappIcon } from 'react-share';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';

const ShareButton = ({ shareUrl, title }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <button 
                onClick={toggleMenu} 
                style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    borderRadius: '50%',
                    color: 'black',
                    fontSize: '24px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s',
                    marginLeft: '20px',
                    marginBottom: '10px',
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#005EC4'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
            >
                <FontAwesomeIcon icon={faShareAlt} style={{
                    marginLeft: '-2px',
                }} />
            </button>
            
            {isOpen && (
                <div 
                    style={{
                        position: 'absolute',
                        top: '40px', 
                        left: '10px',
                        backgroundColor: 'lightgray',
                        borderRadius: '25px',
                        padding: '10px',
                        display: 'flex',
                        gap: '10px',
                        zIndex: 10000,
                    }}
                >
                    <FacebookShareButton url={shareUrl} quote={title}>
                        <FacebookIcon size={40} round={true} bgStyle={{ fill: '#1877F2' }} />
                    </FacebookShareButton>
                    <TwitterShareButton url={shareUrl} title={title}>
                        <div style={{ width: '40px', height: '40px', backgroundColor: '#000', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <FontAwesomeIcon icon={faXTwitter} style={{ color: 'white' }} size="lg" />
                        </div>
                    </TwitterShareButton>
                    <WhatsappShareButton url={shareUrl} title={title}>
                        <WhatsappIcon size={40} round={true} bgStyle={{ fill: 'green' }} />
                    </WhatsappShareButton>
                </div>
            )}
        </div>
    );
};

export default ShareButton;
